import React, { useState, useEffect,useMemo } from "react";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import { Grid, Box, Typography } from "@mui/material";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom/DYCustom';
import AddStaff from "../../Forms/AddStaff/AddStaff";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { StaffCart } from "../StaffCart/StaffCart";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import {
  useGetAllPersonByTenantId,
  useDeletePerson,
  useDeleteInvitedPerson,
} from "../../Hooks";
import EditPerson from "../../Forms/EditPerson/EditPerson";
import { useGetAllPersonPictureByTenantId } from "../../../AllTenantOkrs/Hooks";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const InviteUser = () => {
  const userId = useSelector((state: any) => state.loign.userInfo.userId);
  const userPhoneNumber = useSelector(
    (state: any) => state.loign.userPhoneNumber
  );
  const tenantId: string | null = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const { data: usersData, isLoading: getAllPeronsLoading, isError:dataError} =
    useGetAllPersonByTenantId(tenantId);
  const{data:picData,isLoading:loadingg}=useGetAllPersonPictureByTenantId(tenantId);
  const{mutate:deletePerson,data:deletePersonData,isSuccess:deletePerSuccess}=useDeletePerson();
  const{mutate:deleteInvitedPerson,data:deleteInvitedData,isSuccess}=useDeleteInvitedPerson();
  const [personId, setPersonId] = useState<string | null>(null);
  const [personIdFDelete, setPersonIdFDelete] = useState<string | null>(null);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  // const { mutate: deletePerson } = useDeletePerson();
  const [showAddStaff, setShowAddStaff] = useState<Boolean | null>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [userAsynOpcState, setUserAsyncOpState] = useState<any>(null);
  const [krRowData, setKrRowData] = useState(null);
  const [historyModal, setHistoryModal] = useState(false);
  const [grid, setGrid] = useState(false);
  // const [krId, setKrId] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const initialAddStaff = () => {
    setShowAddStaff((prev: any) => !prev);
  };

  const initialDelete=()=>{
    let{activated,phoneNumber } : any = krRowData;
   if (activated) {
    let deletePersonBody={
        DeletedPersonId:personId,
        UserId:userId,
        TenantId:tenantId
    }
    // console.log(deletePersonBody)
    deletePerson(deletePersonBody);
    //handleClos();
   }
   else{
    let invitedPersonBody={
        phoneNumber:phoneNumber,
        lastModifiedById:userId,
        userId:userId,
        tenantId:tenantId
    }
    // console.log(invitedPersonBody)
    deleteInvitedPerson(invitedPersonBody);
    //handleClos();
   }
}

  useEffect(() => {
    if (personIdFDelete) {
      let deleteBody = {
        phoneNumber: userPhoneNumber,
        lastModifiedById: userId,
        userId: userId,
        tenantId: tenantId,
      };
      console.log(deleteBody);
      deletePerson(deleteBody);
    }
  }, [personIdFDelete]);

  const tenantsColumns: any = useMemo(()=>[
    {
      field: "rowid",
      headerName: "ردیف",
      width: 60,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    },
    { field: 'name',
      align:'left',
      headerName: 'نام',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 170,
      flex:1,
      renderCell: ( par : any) => {
        let idd: string = par?.row?.id;
        let name: string = par?.row?.name;
        return (
          <Box display={"flex"} justifyContent={"center"}>
          <img src={
                  picData !== null && picData !== undefined &&
                  picData.filter((x:any)=>x.personId === idd)[0] !== null &&
                  picData.filter((x:any)=>x.personId === idd)[0]!== undefined
                  ?
                  picData.filter((x:any)=>x.personId === idd)[0].pictureBase64String
                  :''
                } width={'20px'} style={{borderRadius:'50%'}} />
            {'' +name}
          </Box>
          )
      }
    },
    { field: 'userName',
      align:'center',
      headerName: 'شماره تلفن',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 170,
      flex:1,
    },
    { field: 'jobTypeName',
      align:'center',
      headerName: 'عنوان شغلی',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 170,
      flex:1,
    },
    { field: 'activated',
      align:'center',
      headerName: 'وضعیت',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 70,
      flex:1,
      renderCell: ( par : any) => {
        let activated: string = par?.row?.activated;
        return (
          <Box   
            height={'25px'} 
            width={'75px'}
            bgcolor={activated?'#D5f7D4':'#bfd3f5'}  
            borderRadius={2} display={'flex'} 
            alignItems={'center'} 
            justifyContent={'center'}
            >
          <Typography fontSize={'0.7rem'} fontWeight={activated?900:400} color={activated?'green':'#3a82fc'}  >
          {
              activated?'فعال':'دعوت شده'
          }</Typography>
        </Box>
        )
      }
    },

  ],[]);

  return (
    <Grid container>
      <Grid item xs={12} md={12} mx={2}>
        <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
          <Box>
            <DyButton
              caption={"دعوت همکاران"}
              onClick={initialAddStaff}
              color={"red"}
              disbled={false}
              variant={"contained"}
              type={"button"}
              bgColor={"#00387C"}
            />
          </Box>
        </Box>

        <div className="h-11 w-full mr-4 gap-x-2 flex  items-center">
                        <label className="flex gap-x-1 w-2/6 items-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="AddToMyList"
                            value="AddToMyList"
                            id="AddToMyList"
                            defaultChecked={true}
                            onChange={() =>
                              grid === 
                              true?
                              setGrid(
                                false
                              ):
                              setGrid(
                                true
                              )
                            }
                            checked={
                              grid === 
                              true
                            }
                          />
                          <span className="text-md-xs font-weight[600]">نمایش بصورت جدول</span>
                        </label>
                      </div>

        {showAddStaff && (
          <ModalLyt
            showModal={showAddStaff}
            setShowModal={setShowAddStaff}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"دعوت همکاران"}
          >
            <AddStaff
              onSuccesss={initialAddStaff}
              onClose={setShowAddStaff}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}

        {showEditModal && (
          <ModalLyt
            showModal={showEditModal}
            setShowModal={setShowEditModal}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ویرایش کاربر"}
          >
            <EditPerson
              personId={personId}
              onClose={setShowEditModal}
              //  setAsyncOpStatus={setAsyncOpStatus}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}
      </Grid>

      <Grid item xs={12}>
        {getAllPeronsLoading ? (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"99%"}
            py={15}
            boxShadow={4}
            borderRadius={3}
            mx={"auto"}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            width={"100%"}
            display={"flex"}
            flexWrap={"wrap"}
            justifyContent={"start"}
            px={2}
          >
            { !grid ?
              usersData?.map((item: any, i: number) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "withesmoke",
                        // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                        // borderRadius: "12px",
                      },
                      padding: "10px", // Add padding to ensure content isn't cut off during hover
                    }}
                  >
                    <StaffCart
                      setShowEditModal={setShowEditModal}
                      setPersonId={setPersonId}
                      setPersonIdFDelete={setPersonIdFDelete}
                      item={item}
                      personPicture={picData}
                      setShowToastMessage={setShowToastMessage}
                      setDeleteState={setUserAsyncOpState}
                    />
                  </Box>
                )
              }) : 
               <>
                  <DyDataGridCustom
                  rowHeight={10}
                  data={loadingg || dataError || getAllPeronsLoading ? []:usersData }
                  columns={tenantsColumns || []}
                  hideFooter={false}
                  additionalToolbar={true}
                  setSelectionModel={()=>{}}
                  setShowHistory={setShowEditModal}
                  setSpecialId={setPersonId}
                  initialOnRowClick={setKrRowData}
                  initialDelete={initialDelete}
                  /></>
              }
          </Box>
        )}
      </Grid>

      {showToastMessage && (
        <DYToastMessage
          isSuccess={userAsynOpcState?.isSuccess}
          message={userAsynOpcState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}
      <Grid item xs={12}>
        <Box width={"100%"} height={"15px"}></Box>
      </Grid>
    </Grid>
  );
};

export default InviteUser;
